module.exports = "<ol class=\"breadcrumb\">\n    <li ng-repeat=\"step in steps\" ng-class=\"{active: $last}\" ng-switch=\"$last\">\n        <a ng-switch-when=\"false\" href=\"{{step.ncyBreadcrumbLink}}\">{{step.ncyBreadcrumbLabel}}</a>\n        <span ng-switch-when=\"true\">{{step.ncyBreadcrumbLabel}}</span>\n    </li>\n</ol>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/breadcrumbs.html
// module id = 725
// module chunks = 0